(() => {
  function init(root=document) {
    root.querySelectorAll('[data-native-stockists]:not([data-native-ready])').forEach(section => {
      section.dataset.nativeReady='true';
      const tabs=[...section.querySelectorAll('[data-native-tab]')], panels=[...section.querySelectorAll('[data-native-panel]')];
      function select(index, updateHash=false, focus=false) {
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
        panels.forEach((panel,i)=>{panel.hidden=i!==index;});
        if(focus)tabs[index].focus();
        if(updateHash)history.replaceState(null,'','#'+panels[index].id);
      }
      function fromHash(){const found=location.hash.match(/tabs-group-[^-].*-(\d+)$/);select(found?Math.max(0,Math.min(tabs.length-1,Number(found[1])-1)):0);}
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',event=>{event.preventDefault();select(i,true);});
        tab.addEventListener('keydown',event=>{
          let target;
          if(event.key==='ArrowRight'||event.key==='ArrowDown')target=(i+1)%tabs.length;
          if(event.key==='ArrowLeft'||event.key==='ArrowUp')target=(i-1+tabs.length)%tabs.length;
          if(event.key==='Home')target=0;
          if(event.key==='End')target=tabs.length-1;
          if(target!==undefined){event.preventDefault();select(target,true,true);}
        });
      });
      fromHash();window.addEventListener('hashchange',fromHash);
    });
    root.querySelectorAll('[data-native-rail-section]:not([data-native-ready])').forEach(section=>{
      section.dataset.nativeReady='true';
      const rail=section.querySelector('[data-native-rail]'), prev=section.querySelector('[data-rail-direction="-1"]'),next=section.querySelector('[data-rail-direction="1"]');
      if(!rail||!prev||!next)return;
      const measure=()=>{prev.disabled=rail.scrollLeft<=2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
      [prev,next].forEach(button=>button.addEventListener('click',()=>{
        const gap=parseFloat(getComputedStyle(rail).columnGap)||0;
        const width=(rail.firstElementChild?.getBoundingClientRect().width||rail.clientWidth)+gap;
        const count=Math.max(1,Math.floor((rail.clientWidth+gap)/width));
        rail.scrollBy({left:Number(button.dataset.railDirection)*width*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      rail.addEventListener('scroll',measure,{passive:true});new ResizeObserver(measure).observe(rail);measure();
    });
  }
  init();document.addEventListener('shopify:section:load',()=>init());
})();
